class GTCAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log("Accordion connected");
    this.addEventListener("click", (e) => {
      const activePanel = e.target.closest(".gtc__accordion-panel");
      if (!activePanel) return;
      this.toggleAccordion(activePanel);
    });
  }

  toggleAccordion(panelToActivate) {
    const activeButton = panelToActivate.querySelector(
      ".gtc__accordion-trigger"
    );
    const activePanel = panelToActivate.querySelector(
      ".gtc__accordion-content"
    );
    const activePanelIsOpened =
      activeButton.getAttribute("aria-expanded") === "true";

    activeButton.setAttribute("aria-expanded", !activePanelIsOpened);
    activePanel.setAttribute("aria-hidden", activePanelIsOpened);
  }
}

// Define the custom element
customElements.define("gtc-accordion", GTCAccordion);
